import React from 'react';

import RoutesPage from './routes';


function App() {


  return (

    <div className="min-h-dvh overflow-hidden">
     <RoutesPage/>
    </div>
  );
}

export default App;
